import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { SeTaskState } from './state';

const defaultState: SeTaskState = {
  se_tasks: [],
};

export const seTaskModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
